import { TFunction } from 'i18next';

import { SelectCardWrapperPermissionsDetails } from 'types/commons';
import { Job } from 'types/jobs';

import {
  JobStatus,
  PaymentStatus,
  SelectCardWrapperPermissions,
  SubscriptionTypes
} from 'constants/enums';

// const checkIsJobEditAvailable = (
//   jobStatus: JobStatus,
//   isApplications: boolean
// ): {
//   isJobEditAllowed: boolean;
//   jobEditNotAllowedTooltip?: string;
//   isJobEditHidden?: boolean;
// } => {
//   if (jobStatus === JobStatus.Completed) {
//     return {
//       isJobEditAllowed: false,
//       isJobEditHidden: true
//     };
//   }

//   if (isApplications) {
//     return {
//       isJobEditAllowed: false,
//       jobEditNotAllowedTooltip: 'Cannot Edit job with applications.'
//     };
//   }

//   switch (jobStatus) {
//     // without applications
//     case JobStatus.Active:
//     case JobStatus.Inactive: {
//       return {
//         isJobEditAllowed: true
//       };
//     }

//     default: {
//       return {
//         isJobEditAllowed: false
//       };
//     }
//   }
// };

const getJobEditNotAllowedTooltip = (job: Job, t: TFunction) => {
  if (job.status === JobStatus.Completed) {
    return t('bulkActions.job.jobIsClosed');
  }

  if (job.status === JobStatus.InReview) {
    return t('bulkActions.job.jobIsInReview');
  }

  if (job.activeApplications > 0) {
    return t('bulkActions.job.jobHasActiveApplications');
  }

  return '';
};

export const getJobActionsPermissions = (t: TFunction, job?: Job | null) => {
  if (!job) {
    return [];
  }

  // const isJobUnpaid = [
  //   PaymentStatus.Unpaid,
  //   PaymentStatus.Incomplete,
  //   PaymentStatus.IncompleteExpired,
  //   PaymentStatus.PastDue
  // ].includes(job.subscriptionStatus as PaymentStatus);

  const permissions: SelectCardWrapperPermissionsDetails[] = [
    // {
    //   permission: SelectCardWrapperPermissions.JobPay,
    //   isAllowed: isJobUnpaid,
    //   isHidden: !isJobUnpaid
    // },
    {
      permission: SelectCardWrapperPermissions.JobUpgrade,
      isAllowed: job.subscriptionType === SubscriptionTypes.Free,
      isHidden: job.subscriptionType !== SubscriptionTypes.Free,
      allowedTooltip: 'Coming soon'
    },
    {
      permission: SelectCardWrapperPermissions.JobView,
      isAllowed: job.status === JobStatus.Active,
      isHidden: job.status !== JobStatus.Active
    },
    // {
    //   permission: SelectCardWrapperPermissions.JobDelete,
    //   isAllowed: true
    // },
    {
      permission: SelectCardWrapperPermissions.JobCancelSubscription,
      isAllowed: job.subscriptionStatus === PaymentStatus.Active,
      isHidden: job.subscriptionStatus !== PaymentStatus.Active
    },
    {
      permission: SelectCardWrapperPermissions.JobReactivate,
      isAllowed: job?.subscriptionStatus === PaymentStatus.Canceled && job?.status === JobStatus.Inactive,
      isHidden: job?.subscriptionStatus !== PaymentStatus.Canceled || job?.status !== JobStatus.Inactive
    },
    {
      permission: SelectCardWrapperPermissions.JobEdit,
      isAllowed:
        job.status !== JobStatus.Completed &&
        job.status !== JobStatus.InReview &&
        job.activeApplications === 0,
      notAllowedTooltip: getJobEditNotAllowedTooltip(job, t)
    }
  ];

  return permissions;
};
